export default class TemplateBlogsLanding {
    constructor(container, apiEndpoint, redirectUrlIfNoResults, options) {
        
        const defaultOptions = {            
            itemsContainer: '.blog-items',
            featuredContainer: '.blog-featured',
            paginationContainer: '.blog-pagination',
            paginationItemsContainer: '.blog-pagination ul',
            paginationNextButton: '.blog-pagination .next',
            paginationPreviousButton: '.blog-pagination .previous',
            filteredByContainer: '.blog-filtered-by',
            tagsContainer: '.blog-tags-filter',
            itemsPerPage: 9,
            itemsOnPageOne: 7,
            paginationScrollAmount: 43.5
        };

        this.options = Object.assign({}, defaultOptions, options);
        this.allBlogs = [];
        this.sortedBlogs = [];
        this.tags = [];

        this.filterValues = {
            tag: '',
            page: 1
        };

        this.apiEndpoint = apiEndpoint;      
        this.redirectUrlIfNoResults = redirectUrlIfNoResults;

        this.container = document.querySelector(container);
        this.itemsContainer = this.container.querySelector(this.options.itemsContainer);
        this.featuredContainer = this.container.querySelector(this.options.featuredContainer);
        this.paginationItemsContainer = this.container.querySelector(this.options.paginationItemsContainer);
        this.paginationNextButton = this.container.querySelector(this.options.paginationNextButton);
        this.paginationPreviousButton = this.container.querySelector(this.options.paginationPreviousButton);
        this.tagsContainer = this.container.querySelector(this.options.tagsContainer);
        this.filteredByContainer = this.container.querySelector(this.options.filteredByContainer);

        this.init();
        this.initEvents();
    }

    init() {
                
        fetch(this.apiEndpoint)
            .then(response => response.json())
            .then(items =>  {
                                
                this.allBlogs = items;

                this.syncFilterValuesFromQuerystring();

                this.filterAndSortBlogs();

                this.displayBlogs();

                this.renderPagination();

                this.setPaginationScolling();

                this.renderFilterTags();

                this.renderSelectedFilterTag();

                this.container.classList.remove('loading');

            });
    }
    
    initEvents(){

        this.filteredByContainer.querySelector(".remove-filter").addEventListener("click", e => this.removeTag(e));

    }

    syncFilterValuesFromQuerystring(){

        const urlParams = new URLSearchParams(window.location.search);
        
        const tag = urlParams.get('tag');
        const page = urlParams.get('page');

        this.filterValues.tag = tag !== null ? tag : '';
        this.filterValues.page = page !== null ? parseInt(page) : 1;

    }

    filterAndSortBlogs(){

        const filteredItems = this.allBlogs.filter(blogItem => this.shouldDisplayBlog(blogItem));

        this.sortedBlogs = filteredItems.sort((a, b) => new Date(b.date) - new Date(a.date))

    }


    displayBlogs(disableScrollingToTop){

        const paginatedItems = this.paginateItems(this.sortedBlogs);

        if (paginatedItems.length === 0){

            window.location = this.redirectUrlIfNoResults;
            return;            

        }

        if(!disableScrollingToTop){
            window.scrollTo({ top: 0, behavior: 'smooth'});
        }
       

        if(this.filterValues.page === 1)
        {
            this.renderFeaturedItem(paginatedItems[0]);
            
            this.renderItems(paginatedItems.slice(1));         
        }
        else
        {
            this.featuredContainer.style.display = 'none';

            this.renderItems(paginatedItems); 
        }

    }

    shouldDisplayBlog(blogItem){
       
        if (this.filterValues.tag === '')
            return true;

        return blogItem.tags
                    .some(blogTag => this.filterValues.tag == blogTag.key);

    }


    paginateItems(items){

        let skip = 0;
        let take = 0;

        if(this.filterValues.page === 1)
        {
            skip = 0;
            take = this.options.itemsOnPageOne;
        }
        else
        {
            var diff = this.options.itemsPerPage - this.options.itemsOnPageOne;
            skip = ((this.filterValues.page - 1) * this.options.itemsPerPage) - diff;
            take = this.options.itemsPerPage + skip;
        }
     
        return items.slice(skip, take); 

    }

    renderFeaturedItem(item){

        this.featuredContainer.innerHTML = this.renderItem(item, item.images.featuredImageUrl, item.text);

        this.featuredContainer.style.display = 'flex';
    }

    renderItems(items){

        let html = "";

        items.forEach(item=> {

            html+= `<div class="blog-item">
                        ${this.renderItem(item, item.images.listImageUrl, item.text.substring(0, 100))}
                    </div>`;
        
        });

        this.itemsContainer.innerHTML = html;        

    }

    renderItem(item, imageUrl, text){

        return `<a href="${item.url}" class="blog-image-container">
                    <picture>
                        <img class="blog-image" src="${imageUrl}" alt="${item.imageAltText}" />
                    </picture>
                </a>
                <div class="blog-content">
                    <span class="blog-properties">
                        <span class="date">${item.dateFormatted}</span> | <span class="tags">${this.renderBlogTags(item)}</span>                                
                    </span>
                    <a href="${item.url}">
                        <h3 class="blog-title">${item.name}</h3>                            
                        <p class="text">${text}...</p>
                    </a>
                </div>`;
    }


    renderBlogTags(blogItem){
        if (blogItem.tags === null || blogItem.tags.length === 0)
            return ''

        let html = ''
        const lastTagKey = blogItem.tags[blogItem.tags.length - 1].key

        blogItem.tags.forEach((tag, index) => {
            const comma = index !== blogItem.tags.length - 1 ? ',' : ''
            html += `<a class="tag"
                        href="?tag=${tag.key}"
                        title="${tag.name}">
                        ${tag.name}${comma}
                    </a>`
        })

        return html
    }


    renderPagination(){

        const totalPages = this.getTotalPages();

        let html = '';

        for(let page = 1; page <= totalPages; page++){

            const activeClass = this.filterValues.page === page ? 'active' : '';
            
            html+= `<li class="${activeClass}">${page}</li>`;

        }

        this.paginationItemsContainer.innerHTML = html;

        if(totalPages > 5){

            this.paginationItemsContainer.classList.remove("less-than-6");
            this.paginationNextButton.style.display = 'block';
            this.paginationPreviousButton.style.display = 'block';
            this.paginationPreviousButton.classList.add("disabled");

        }
        else
        {
            this.paginationItemsContainer.classList.add("less-than-6");
            this.paginationNextButton.style.display = 'none';
            this.paginationPreviousButton.style.display = 'none'
        }

        // Add events
        this.paginationItemsContainer.querySelectorAll('li')
                .forEach(paginationElem => {

                    paginationElem.addEventListener('click', e => this.changePage(e) );

                });

        // Scroll to the active pagination item
        const activePageItem = this.paginationItemsContainer.querySelector(".active");
        if(activePageItem){                      
            const scrollAmount = this.options.paginationScrollAmount * (this.filterValues.page - 1);
            this.paginationItemsContainer.scrollLeft = scrollAmount - 10;
        }
        
    }

    changePage(e){

        const elem = e.target;

        if(elem.classList.contains('active'))
            return;

        this.filterValues.page = parseInt(elem.innerText);
        
        this.displayBlogs(true);
        
        this.paginationItemsContainer.scrollIntoView(
            {
                block: "center", 
                behavior: "smooth"
            });        

        this.updateQueryStrings();

        this.paginationItemsContainer.querySelector('.active').classList.remove('active');
        elem.classList.add('active');
    }


    setPaginationScolling(){

        this.paginationNextButton
            .addEventListener('click', (e) => this.paginationScrollRight(e));
            
        this.paginationPreviousButton
            .addEventListener('click', (e) => this.paginationScrollLeft(e));

        this.paginationItemsContainer
            .addEventListener('scrollend', (e) => this.paginationChangeScroll(e));

    }

    paginationChangeScroll(e){

        const elem = e.target;
        
        const reachEnd = (elem.scrollLeft + elem.offsetWidth) >= (elem.scrollWidth - 1);
        const reachStart = elem.scrollLeft === 0;        

        if(reachStart){
            this.paginationPreviousButton.classList.add("disabled");
            this.paginationNextButton.classList.remove("disabled");
        }
        else if (reachEnd){
            this.paginationPreviousButton.classList.remove("disabled");
            this.paginationNextButton.classList.add("disabled");
        }
        else{
            this.paginationPreviousButton.classList.remove("disabled");
            this.paginationNextButton.classList.remove("disabled");
        }

    }

    paginationScrollRight(){
        
        this.paginationItemsContainer.scrollLeft += this.options.paginationScrollAmount;

    }

    paginationScrollLeft(){
        
        this.paginationItemsContainer.scrollLeft -= this.options.paginationScrollAmount;

    }


    getTotalPages(){

        var totalItems = this.sortedBlogs.length;
        
        if(totalItems > this.options.itemsOnPageOne){

            totalItems -= this.options.itemsOnPageOne;

            var totalPages = Math.ceil(totalItems/this.options.itemsPerPage);

            return totalPages + 1; // Adds one for the X number of item on page one
        }

        return 1;

    }


    renderFilterTags(){

        this.tags = this.getDistinctTags();

        let html = '';

        this.tags.forEach(tag=> {

            html+= `<li data-key="${tag.key}">${tag.name}</li>`;

        });

        this.tagsContainer.querySelector("ul").innerHTML = html;
        this.tagsContainer.style.display = 'flex';

        // Add events
        this.tagsContainer.querySelectorAll('li')
                .forEach(tagElem => {

                    tagElem.addEventListener('click', e => this.changeTag(e) );

                });

    }

    renderSelectedFilterTag(){

        if(!this.filterValues.tag){
            this.filteredByContainer.style.display = 'none';
            return;
        }

        const selectedTag = this.tags.filter(tag => tag.key === this.filterValues.tag)[0];
        if(!selectedTag){
            this.filteredByContainer.style.display = 'none';
            return;
        }
        
        this.filteredByContainer.querySelector("strong").innerHTML = selectedTag.name;
        this.filteredByContainer.style.display = 'block';
    }

    changeTag(e){

        const elem = e.target;

        this.filterValues.tag = elem.dataset.key;
        this.filterValues.page = 1;

        this.filterAndSortBlogs();

        this.displayBlogs();

        this.renderPagination();

        this.updateQueryStrings();

        this.renderSelectedFilterTag();
    }

    removeTag(){

        this.filterValues.tag = '';
        this.filterValues.page = 1;

        this.filterAndSortBlogs();

        this.displayBlogs();

        this.renderPagination();

        this.updateQueryStrings();

        this.renderSelectedFilterTag();
    }

    getDistinctTags(){

        const allTags = [];

        this.allBlogs.forEach(blog=> {

            blog.tags.forEach(blogTag => {

                const tagExist = allTags.some(tag=> tag.key == blogTag.key);
                if(!tagExist){

                    allTags.push(blogTag);

                }
                    
            });

        });

        return allTags;
    }


    updateQueryStrings(){

        const queries = [];

        if(this.filterValues.tag !== ''){
            queries.push(`tag=${this.filterValues.tag}`);
        }

        queries.push(`page=${this.filterValues.page}`);

        history.pushState(null, null, `?${queries.join('&')}`);
    }
}